import React, { useEffect } from "react";
import { setPageMeta } from "../seo/setPageMeta";

export default function Meetings() {
  useEffect(() => {
    setPageMeta({
      title: "Meeting Information | Celebrate Recovery Independence KY",
      description:
        "Find Celebrate Recovery meeting information including schedule, location, and leadership. Join us Thursday evenings in Independence, Kentucky.",
      canonical: "https://www.crindependenceky.com/meetings",
    });
  }, []);

  return (
    <section>
      <h2 className="page-title">Meeting Information</h2>
      <p className="page-intro">
        Join us every Thursday evening for encouragement, worship, teaching,
        testimony, and recovery in a safe Christ-centered environment.
      </p>

      <div className="grid-2">
        <div className="card">
          <h3>Weekly Schedule</h3>
          <p>
            <strong>Thursday</strong>
          </p>
          <p>7:00 PM – Celebrate Recovery gathering begins</p>
        </div>

        <div className="card">
          <h3>Leadership</h3>
          <p>John and Terri Daugherty serve as the group leaders.</p>
        </div>

        <div className="card">
          <h3>Location</h3>
          <p>Community Family Church</p>
          <p>11875 Taylor Mill Rd, Independence, Kentucky 41051</p>
          <p>Room F227, 2nd Floor of the Family Life Center</p>
        </div>

        <div className="card">
          <h3>Questions Before You Come?</h3>
          <p>
            Visit the Contact page or submit a prayer request if you would like
            someone to reach out before your first visit.
          </p>
        </div>

        <div className="card">
          <h3>Register for Celebrate Recovery</h3>
          <p>
            Celebrate Recovery is hosted by Community Family Church. Registration
            and small group information are handled through the church website.
          </p>

          <div className="button-row">
            <a
              href="https://www.cfcky.com/support-small-groups/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              Register at Community Family Church
            </a>
          </div>
        </div>

        <div className="card">
          <h3>First Visit Encouragement</h3>
          <p>
            You do not have to have everything figured out before you come. Just
            take the next step and know that you will be welcomed with grace,
            kindness, and respect.
          </p>
        </div>
      </div>
    </section>
  );
}
